<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <hb-datepicker-control
      [controlId]="control.key"
      [placeholderText]="control.placeholder || control.label"
      [isDisabled]="control.disabled"
      [name]="control.key"
      [formControl]="control.formControl"
      [formControlName]="control.key"
      [orientation]="control.orientation"
      [showClearButton]="control.showClearButton"
      [endDate]="control.maxDate"
      [ngClass]="{ 'is-invalid': control.enableValidation && control.form?.submitted && control.isInvalid }"
    ></hb-datepicker-control>
    <div
      *ngIf="control.enableValidation && control.form?.submitted && control.isInvalid"
      class="primeng-invalid-feedback div-word-wrap validation-error-text"
    >
      <div *ngIf="control.formControl.errors.required" [pTooltip]="control.label + ' is required.'">{{ control.label }} is required.</div>
    </div>
  </div>
</div>
